import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { ServiceType } from '../models';

import { RootState } from '@/store/store';
import { API_FLEET_URL } from '@/utils';

const servicesTypesService = createApi({
  reducerPath: 'servicesTypesService',
  baseQuery: fetchBaseQuery({ baseUrl: `${API_FLEET_URL}/service-types`,
        prepareHeaders: (headers, { getState }) => {
          const state = getState() as RootState;
    
          const token = state.auth?.auth?.accessToken || null;
          if (token) {
            headers.set('Authorization', `Bearer ${token}`);
          }
          return headers;
        },
   }),
  endpoints: (builder) => ({
    getServicesTypes: builder.query<ServiceType[], void>({
      query: () => '',
      transformResponse: (response: { items: ServiceType[] }) => response.items,
    }),
  }),
});

export default servicesTypesService;

export const {
  useGetServicesTypesQuery,
} = servicesTypesService;
